
// ==================================================
// UI Enhancements
// ==================================================

// Calculate header height for scroll jumps
// Called by <script src="{{ 'rrg-custom.js' | asset_url }}" defer></script> in theme.liquid
  (() => {
    const header =
      document.querySelector('#shopify-section-header') ||
      document.querySelector('.section-header') ||
      document.querySelector('header');

    if (!header) return;

    const updateHeaderHeight = () => {
      const headerHeight = Math.ceil(header.getBoundingClientRect().height);

      document.documentElement.style.setProperty(
        '--rrg-header-height',
        `${headerHeight}px`
      );
    };

    updateHeaderHeight();

    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(header);

    window.addEventListener('resize', updateHeaderHeight);
  })();


// ==================================================
// Collection Enhancements
// ==================================================

/**
 * Default Collection Filter: In Stock
 *
 * Automatically enables the "In Stock" filter on collection pages
 * unless the visitor has already applied filters.
 */

(() => {
  const path = window.location.pathname;

  // Only run on individual collection pages.
  if (!path.startsWith('/collections/')) return;

  const url = new URL(window.location.href);

  // Leave existing filters alone.
  const hasFilter = [...url.searchParams.keys()].some((key) =>
    key.startsWith('filter.')
  );

  if (hasFilter) return;

  url.searchParams.set('filter.v.availability', '1');

  window.location.replace(url.toString());
})();
